import { useState } from "react";
import { Button, inputClass } from "@/components/base";
import { api, errCode, errMsg } from "@/lib/api";
import { tic } from "@/lib/sound";

export default function AgencyPlacer({ radarId, onPlaced, onUnlock, title = "Où es-tu sur cette carte ?", bare = false, notFound = "On ne te trouve pas sur cette recherche" }) {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    const agency = name.trim();
    if (!agency || busy) return;
    tic();
    setBusy(true);
    setMsg(null);
    try {
      const r = await api.post(`/radar/${radarId}/place`, { agency });
      if (r.data.user?.status !== "found") setMsg({ type: "not-found", text: notFound });
      onPlaced(r.data);
    } catch (err) {
      const limit = errCode(err) === "too_many_attempts";
      setMsg({ type: limit ? "limit" : "error", text: limit ? errMsg(err) : "Le radar n'a pas abouti. Réessaie dans un instant." });
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="agency-placer" data-cta-guard="" className={bare ? "" : "fade-up rounded-card border border-line bg-surface px-4 py-3.5 sm:px-5 sm:py-4"} aria-label={title}>
      <h2 className="text-[16px] font-semibold tracking-[-0.01em] text-ink" data-testid="agency-placer-title">
        {title}
      </h2>
      <form onSubmit={submit} className="mt-2.5 flex gap-2" noValidate>
        <input
          data-testid="agency-input"
          className={`${inputClass} min-w-0 flex-1`}
          placeholder="Nom de ton agence"
          aria-label="Nom de ton agence"
          maxLength={120}
          value={name}
          onChange={(e) => setName(e.target.value)}
          enterKeyHint="go"
        />
        <Button type="submit" variant="outline" disabled={!name.trim() || busy} data-testid="place-btn" className="shrink-0 px-4 sm:px-5">
          {busy ? "Recherche..." : "Me placer"}
        </Button>
      </form>
      {msg && (
        <p data-testid={`place-${msg.type}`} className={`mt-2.5 text-[14px] ${msg.type === "not-found" ? "text-ink/80" : "err-msg text-ink"}`}>
          {msg.text}
        </p>
      )}
      {msg?.type === "limit" && onUnlock && (
        <button type="button" onClick={onUnlock} data-testid="place-limit-signup" className="mt-1.5 text-[14px] font-medium text-accent hover:underline">
          Créer mon compte
        </button>
      )}
    </section>
  );
}
